import { FileListLoadingStatus } from '../Schema/FileListLoadingStatus';
import { RecentFilesList } from '../Schema/RecentFilesList';
import { getRecentFilesStore } from '../store/RecentFilesStore';

// Returns the current (or default) recent files list for a group
export function getRecentFilesList(groupSmtp: string): RecentFilesList {
    const recentFilesStore = getRecentFilesStore();
    const currentRecentFilesList = recentFilesStore.recentFilesPerGroup.get(groupSmtp);

    if (!currentRecentFilesList) {
        // Create list with default values when group smtp not found in the recent files list map (undefined)
        return {
            fileItems: null,
            fileListCacheLoadingStatus: FileListLoadingStatus.none,
            fileListRefreshLoadingStatus: FileListLoadingStatus.none,
            fileListCacheErrorStatus: '',
            fileListRefreshErrorStatus: '',
            filesHash: '',
        };
    }

    // Make a shallow copy of the list object when group smtp is found in the map
    return {
        fileItems: currentRecentFilesList.fileItems ? currentRecentFilesList.fileItems.slice() : [],
        fileListCacheLoadingStatus: currentRecentFilesList.fileListCacheLoadingStatus,
        fileListCacheErrorStatus: currentRecentFilesList.fileListCacheErrorStatus,
        fileListRefreshLoadingStatus: currentRecentFilesList.fileListRefreshLoadingStatus,
        fileListRefreshErrorStatus: currentRecentFilesList.fileListRefreshErrorStatus,
        filesHash: currentRecentFilesList.filesHash,
    };
}
